import React from 'react';
import { Switch, Route, Redirect } from 'react-router';
import { Routing } from '../core/Routing';
import { BasePage } from './Base';

type Props = {};

export const MainRouting = (_props: Props) => {
	return (
		<>
			<Switch>
				<Route path={Routing.main.base}>
					<BasePage />
				</Route>
				<Redirect from="*" to={Routing.main.base} />
			</Switch>
		</>
	);
};
